import React from "react";
import { useLogStore } from "@/store";
import cn from "classnames";
import { Editor } from "@monaco-editor/react";

export function LogStore() {
  const { logs, clearLogs } = useLogStore();
  const [activeLog, setActiveLog] = React.useState<string | null>(null);

  return (
    <div className="w-full h-full flex bg-slate-700">
      <div className="w-96 flex flex-col items-center">
        <button
          className="w-3/4 p-2 bg-red-600 hover:bg-red-700 text-white font-bold cursor-pointer"
          onClick={clearLogs}
        >
          Clear Logs
        </button>
        <ul className="p-2 space-y-2 overflow-y-auto h-full">
          {logs
            .sort((a, b) => b.time - a.time)
            .map((log) => (
              <li
                key={log.id}
                className={cn("p-2 rounded hover:bg-slate-600 cursor-pointer", {
                  "bg-slate-600": activeLog === log.id,
                  "bg-slate-800": activeLog !== log.id,
                })}
                onClick={() => setActiveLog(log.id)}
              >
                <div className="text-xs text-slate-200 flex space-x-2">
                  <span>{new Date(log.time).toLocaleTimeString()}</span>
                  <span className="font-mono">{log.key}</span>
                </div>
              </li>
            ))}
        </ul>
      </div>
      <div className="flex-1 overflow-auto p-2 border-l border-white">
        {activeLog && logs.find((log) => log.id === activeLog)?.value ? (
          <Editor
            height="100%"
            defaultLanguage={logs.find((log) => log.id === activeLog)?.lang}
            value={logs.find((log) => log.id === activeLog)?.value}
            options={{ readOnly: true }}
          />
        ) : (
          <div className="text-slate-400">
            Select a log entry to view details.
          </div>
        )}
      </div>
    </div>
  );
}
